import { Component } from 'react';
import { actions, Control } from 'forms/rrf';
import { FormGroup, FormLabel } from 'react-bootstrap';
import 'react-datetime/css/react-datetime.css';
import DateTime from 'react-datetime';
import PropTypes from 'prop-types';
import store from '../../../../store';

class DateOfBirthSelector extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  handleChange = (model, value) => {
    if (typeof value === 'object') {
      store.dispatch(actions.change(model, value.format('DD/MM/YYYY')));
    } else {
      store.dispatch(actions.change(model, ''));
    }
    this.setState({ open: false });
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  render() {
    const { model } = this.props;

    return (
      <FormGroup className={`form-group ignite-datepicker ${this.state.date_of_birth ? 'has-'.concat(this.state.date_of_birth) : ''}`} controlId="dateOfBirth">
        <FormLabel>
          Date of Birth (DD/MM/YYYY)
        </FormLabel>
        <Control.text
          changeAction={this.handleChange}
          component={DateTime}
          controlProps={{
            timeFormat: false,
            dateFormat: 'DD/MM/YYYY',
            open: this.state.open,
            onFocus: () => this.setState({ open: true }),
            onBlur: () => this.setState({ open: false }),
            inputProps: {
              disabled: !!this.props.disabled
            }
          }}
          model={model}
        />
      </FormGroup>
    );
  }
}

DateOfBirthSelector.propTypes = {
  model: PropTypes.string,
};

DateOfBirthSelector.defaultProps = {
  model: '.date_of_birth',
};

export default DateOfBirthSelector;
